import styles from "./content.module.scss";

type Props = {
  children: React.ReactNode;
};

const Content = ({ children }: Props) => {
  return <main className={styles.content}>{children}</main>;
};

export default Content;
